import React from 'react';
import NavBar from './navBar';

const AppWrapper = (props) => {

    return (
      <React.Fragment>
        <NavBar {...props} />
        <div className={`row ${props.className}`}>
          <div className="column small-12 large-11 large-offset-0-5">
            {props.children}
          </div>
        </div>
      </React.Fragment>
    )
}

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/components/shared/appWrapper.js